/**
 * Compact knockout slot labels for UI (FIFA-style: 1E, 2A, W73, 3:a A/B/C/D/F).
 * Backend keeps full English placeholders; use title= for full string on tap/hover.
 */
export function formatKnockoutPlaceholder(text, lang = "sv") {
  const s = (text || "").trim();
  if (!s) return "";

  let m = s.match(/^Winner Group ([A-L])$/i);
  if (m) return `1${m[1].toUpperCase()}`;

  m = s.match(/^Runner-up Group ([A-L])$/i);
  if (m) return `2${m[1].toUpperCase()}`;

  m = s.match(/^Best 3rd (.+)$/i);
  if (m) {
    const groups = m[1].trim();
    return lang === "en" ? `3rd ${groups}` : `3:a ${groups}`;
  }

  m = s.match(/^Winner Match (\d+)$/i);
  if (m) return lang === "en" ? `W${m[1]}` : `V${m[1]}`;

  m = s.match(/^Loser Match (\d+)$/i);
  if (m) return lang === "en" ? `L${m[1]}` : `F${m[1]}`;

  return s;
}

/** Display name for a team slot (code, placeholder, or TBD). */
export function formatMatchTeamLabel({ code, placeholder, teamName, tbdLabel, lang = "sv" }) {
  if (code && teamName) return teamName;
  if (placeholder) return formatKnockoutPlaceholder(placeholder, lang);
  return tbdLabel || "–";
}
